import { getRevisionFacturas } from "../services/pedidos.services";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

export const useRevisionFacturas = (initialState, urlInvoiceApi) => {
    const headersApi = useSelector(state => state.url.headersAPI)
    const [facturas, setFacturas] = useState(initialState)

    const getData = async() => {
        const data = await getRevisionFacturas({ headers: headersApi, urlInvoiceApi: urlInvoiceApi })
        setFacturas(() => data)
    }

    useEffect(() => {
        getData()
    }, [])
    
    return (
        [facturas]
    )
}